var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4141 17.4141C17.0234 17.8047 16.5469 18 15.9844 18H2.01562C1.45312 18 0.976562 17.8047 0.585938 17.4141C0.195312 17.0234 0 16.5469 0 15.9844V2.01562C0 1.42188 0.1875 0.9375 0.5625 0.5625C0.9375 0.1875 1.42188 0 2.01562 0H15.9844C16.5469 0 17.0234 0.1875 17.4141 0.5625C17.8047 0.9375 18 1.42188 18 2.01562V15.9844C18 16.5469 17.8047 17.0234 17.4141 17.4141ZM2.71379 9.70475L6.98437 14.0156L15.2811 5.71884C15.6714 5.32861 15.6765 4.69754 15.2928 4.30096C14.9 3.89509 14.2508 3.88977 13.8515 4.28915L6.98437 11.1562L4.12664 8.29852C3.7374 7.90928 3.10633 7.90928 2.71709 8.29852C2.32914 8.68646 2.32767 9.31499 2.71379 9.70475Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.529c48000212b7ef07a1e926e5470f35.svg";
export { ForwardRef as ReactComponent };